import FormInputSelectComponent from "../../components/atoms/form-input/form-input-select/form-input-select.component";
import FooterComponent from "../Footer/footer.component";
import HeaderComponent from "../Header/header.component";

const BomColumnMappingTemplate = ({
  templateModal: { bomData, loading },
  templateEvents: { handleChange, handleSubmit },
}) => {
  console.log({ bomData });
  return (
    <>
      {/* <HeaderComponent /> */}
      <section className="page-navtab-content page-bg py-4">
        <div className="container">
          <div className="card-body text-center p-4 p-md-5">
            <div className="mb-5">
              <h3 className="mb-3 fw-semibold text-primary">
                Map Your BOM Columns
              </h3>
              <p className="text-muted mb-0">
                Please select the appropriate columns from your uploaded file
              </p>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-8">
                <div className="form-group text-start mb-4">
                  <FormInputSelectComponent
                    id="columnRow"
                    name="columnRow"
                    label={
                      <span className="d-flex align-items-center">
                        <i className="bi bi-list-ol me-2"></i>
                        Select Header Row
                      </span>
                    }
                    isVertical
                    options={bomData?.rows || []}
                    onChange={(value) => handleChange("columnRow", value)}
                    className="form-control-lg"
                  />
                </div>

                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="form-group text-start">
                      <FormInputSelectComponent
                        id="partnumber"
                        name="partnumber"
                        label={
                          <span className="d-flex align-items-center">
                            <i className="bi bi-upc-scan me-2"></i>
                            Part Number Column
                          </span>
                        }
                        isVertical
                        options={bomData?.columns || []}
                        onChange={(value) =>
                          handleChange("partNumberKey", value)
                        }
                        className="form-control-lg"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group text-start">
                      <FormInputSelectComponent
                        id="qty"
                        name="qty"
                        label={
                          <span className="d-flex align-items-center">
                            <i className="bi bi-123 me-2"></i>
                            Quantity Column
                          </span>
                        }
                        isVertical
                        options={bomData?.columns || []}
                        onChange={(value) => handleChange("qtyKey", value)}
                        className="form-control-lg"
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-3 pt-3">
                  <button
                    className="btn btn-primary"
                    style={{ width: "100%" }}
                    onClick={handleSubmit}
                    // disabled={loading}
                  >
                    <i className="bi bi-check-circle me-2"></i>
                    {loading ? "Loading..." : "Confirm Mapping"}
                  </button>
                </div>
              </div>

              {/* Preview Table */}
              {bomData.columnsUpdated && (
                <div className="inventory-container">
                  <div className="container-fluid">
                    <div className="card border-0 shadow-lg mt-4 rounded-4 overflow-hidden">
                      <div
                        className="card-header fw-semibold d-flex justify-content-center align-items-center"
                        style={{
                          background:
                            "linear-gradient(135deg, #f8f9fa, #e9ecef)",
                          fontSize: "1.1rem",
                        }}
                      >
                        <i className="bi bi-table me-2 text-primary"></i>
                        File Preview
                      </div>

                      <div className="card-body p-0 mt-2">
                        <div className="table-responsive">
                          <table className="table table-hover align-middle mb-0">
                            <thead
                              className="table-light"
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                                background: "#f1f3f5",
                              }}
                            >
                              <tr style={{ borderBottom: "2px solid #dee2e6" }}>
                                <th
                                  style={{ width: "80px" }}
                                  className="text-center text-secondary"
                                >
                                  #
                                </th>
                                {bomData.columns?.map((column, index) => (
                                  <th
                                    key={`header-${index}`}
                                    className="text-nowrap fw-semibold text-dark"
                                    style={{ fontSize: "0.95rem" }}
                                  >
                                    {column.name}
                                  </th>
                                ))}
                              </tr>
                            </thead>

                            <tbody>
                              {bomData.rows
                                .filter(
                                  (row, index) =>
                                    index > parseInt(bomData.columnRow)
                                )
                                .map((row, index) => (
                                  <tr
                                    key={`row-${index}`}
                                    className="table-row-custom"
                                  >
                                    <td className="text-center fw-bold text-muted">
                                      {index + 1}
                                    </td>

                                    {row.row.map((item, cellIndex) => (
                                      <td
                                        key={`cell-${index}-${cellIndex}`}
                                        className="text-truncate"
                                        style={{ maxWidth: "220px" }}
                                        title={item}
                                      >
                                        {item || (
                                          <span className="text-muted fst-italic">
                                            —
                                          </span>
                                        )}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* <FooterComponent /> */}
    </>
  );
};

export default BomColumnMappingTemplate;
